// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__-2sBE","customEmbroidery":"Footer_customEmbroidery__Vc61u"};